"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIRTUAL_ACCOUNT_ADD = exports.FUND_ANCLAP_CARD = exports.GROUP_OTHER_ENTERPRISE_PAYOUTS = exports.BRIDGE_PAYIN = exports.BRIDGE_PAYOUT = exports.WEB3_PAYOUT = exports.WEB3_PAYIN = exports.NO_SHOW_FEE = exports.CARD_UNLOAD = exports.CARD_RELOAD = exports.CARD_REFUND = exports.CARD_PAYMENT = exports.CARD_PURCHASE = exports.GROUP_CRYPTO = exports.GROUP_PEER_TO_PEER = exports.PROMOTION_REWARD = exports.PAYONEER_DIRECT_ADD = exports.MERGED_PEER_TO_PEER = exports.INVITEE_REWARD = exports.REFERRER_REWARD = exports.DEBIT_DIRECT_BUY = exports.DIRECT_SELL_WYRE_WIRE = exports.DIRECT_SELL_DLOCAL = exports.DIRECT_SELL = exports.DIRECT_BUY = exports.ENTERPRISE_PAYOUT = exports.PAYMENT = exports.STELLAR_DIRECT_WITHDRAW = exports.CRYPTO_DIRECT_SELL = exports.STELLAR_DIRECT_ADD = exports.MOONPAY_DIRECT_WITHDRAW = exports.MOONPAY_DIRECT_ADD = exports.CRYPTO_DIRECT_BUY = exports.CRYPTO_SELL = exports.CRYPTO_BUY = exports.SEND_REQUEST = exports.WYRE_CRYPTO_SEND = exports.SEND = exports.SELL = exports.BUY = void 0;
exports.BUY = 'BUY';
exports.SELL = 'SELL';
exports.SEND = 'SEND';
exports.WYRE_CRYPTO_SEND = 'WYRE_CRYPTO_SEND';
exports.SEND_REQUEST = 'SEND_REQUEST';
exports.CRYPTO_BUY = 'CRYPTO_BUY';
exports.CRYPTO_SELL = 'CRYPTO_SELL';
exports.CRYPTO_DIRECT_BUY = 'CRYPTO_DIRECT_BUY';
exports.MOONPAY_DIRECT_ADD = 'MOONPAY_DIRECT_ADD';
exports.MOONPAY_DIRECT_WITHDRAW = 'MOONPAY_DIRECT_WITHDRAW';
exports.STELLAR_DIRECT_ADD = 'STELLAR_DIRECT_ADD';
exports.CRYPTO_DIRECT_SELL = 'CRYPTO_DIRECT_SELL';
exports.STELLAR_DIRECT_WITHDRAW = 'STELLAR_DIRECT_WITHDRAW';
exports.PAYMENT = 'PAYMENT';
exports.ENTERPRISE_PAYOUT = 'ENTERPRISE_PAYOUT';
exports.DIRECT_BUY = 'DIRECT_BUY';
exports.DIRECT_SELL = 'DIRECT_SELL';
exports.DIRECT_SELL_DLOCAL = 'DIRECT_SELL_DLOCAL';
exports.DIRECT_SELL_WYRE_WIRE = 'DIRECT_SELL_WYRE_WIRE';
exports.DEBIT_DIRECT_BUY = 'DEBIT_DIRECT_BUY';
exports.REFERRER_REWARD = 'REFERRER_REWARD';
exports.INVITEE_REWARD = 'INVITEE_REWARD';
exports.MERGED_PEER_TO_PEER = 'MERGED_PEER_TO_PEER';
exports.PAYONEER_DIRECT_ADD = 'PAYONEER_DIRECT_ADD';
exports.PROMOTION_REWARD = 'PROMOTION_REWARD';
exports.GROUP_PEER_TO_PEER = [exports.BUY, exports.SELL];
exports.GROUP_CRYPTO = [exports.CRYPTO_BUY, exports.CRYPTO_SELL];
exports.CARD_PURCHASE = 'CARD_PURCHASE';
exports.CARD_PAYMENT = 'CARD_PAYMENT';
exports.CARD_REFUND = 'CARD_REFUND';
exports.CARD_RELOAD = 'CARD_RELOAD';
exports.CARD_UNLOAD = 'CARD_UNLOAD';
exports.NO_SHOW_FEE = 'NO_SHOW_FEE';
exports.WEB3_PAYIN = 'WEB3_PAYIN';
exports.WEB3_PAYOUT = 'WEB3_PAYOUT';
exports.BRIDGE_PAYOUT = 'BRIDGE_PAYOUT';
exports.BRIDGE_PAYIN = 'BRIDGE_PAYIN';
exports.GROUP_OTHER_ENTERPRISE_PAYOUTS = [exports.BRIDGE_PAYOUT, exports.WEB3_PAYOUT];
exports.FUND_ANCLAP_CARD = 'FUND_ANCLAP_CARD';
exports.VIRTUAL_ACCOUNT_ADD = 'VIRTUAL_ACCOUNT_ADD';
